export default "__VITE_ASSET__D8fgM0u8__"